import { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const DeliveryIcon: FC<SvgProps> = ({ fill, ...props }) => {
    return (
        <Svg viewBox="0 0 48 48" width="48" height="48" fill="none" {...props}>
            <Path
                fill={fill || 'currentColor'}
                d="M15.7 37h17.6l1.15-15.5h-19.9L15.7 37Zm-1.35-18.5h20.3l.25-3.65-6-5.85h-8.8l-6 5.85.25 3.65Zm-2.85 2.7-6-6.3c-.3-.3-.441-.65-.424-1.05.016-.4.175-.75.475-1.05.3-.3.658-.45 1.075-.45.416 0 .775.15 1.075.45l3.55 3.65L11 13.9l6.9-7c.266-.267.587-.483.963-.65.376-.167.772-.25 1.186-.25h8.9c.415 0 .81.083 1.187.25.376.167.697.383.963.65l6.9 7-.25 2.55 3.55-3.65c.3-.3.659-.45 1.076-.45.416 0 .775.15 1.075.45.3.3.458.65.474 1.05.017.4-.124.75-.424 1.05l-6 6.3h-26ZM15.7 40c-.766 0-1.441-.275-2.024-.825-.584-.55-.909-1.208-.976-1.975l-1.2-16h26l-1.2 16c-.066.767-.391 1.425-.974 1.975-.584.55-1.259.825-2.026.825H15.7Z"
            />
        </Svg>
    )
}

export default DeliveryIcon
